import request from "./request"; 

export const apiRequest = ({ endpoint, method = "GET", data = null }) => {
  return request({ url: endpoint, method, data });
};
